Apt.fn.make('account.team', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;

		priv.id = $.context('id');

		if (! priv.id) {
			priv.render();

			return;
		}

		LS.api.get('me/teams/' + priv.id, {
			auth: true,
			success: data => {
				priv.render(data);
			}
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('team');
	}
}, {
	/**
	 * Render view
	 *
	 * @param {Object} [data]
	 */
	render(data) {
		const $entry = $$('entry');
		const id = this.id;

		$entry.html(
			$.view.render($$('template')[0].textContent, data)
		)
			.removeClass('g-loading');

		LS.api.bind($entry, 'me/teams' + (id ? '/' + id : ''), {
			namespace: 'team',
			method: id ?
				'patch' : 'post',
			success: data => {
				if (data.id) {
					$.history.go('/account/teams/' + data.id);
				}
			}
		});
	}
});